// return the first letter in capital - input: fname | output: Fname
export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// extract the productName from url - sample url: https://www.ibm.com/products/productName/pricing# | output - productName
export const extractProductName = (url: string) => {
  const products = url.match(/\/products\/([^\/]+)/);
  return products ? products[1] : null;
};

// preparing the omnichannel config json based on environment
export const prepareProductsUrl = () => {
  const environment = window.location.host;
  if (environment === 'www.ibm.com') {
    return `https://emailer.5bcb70fa.public.multi-containers.ibm.com/store/bucket/production/omnichannel.json`;
  } else {
    return `https://emailer-test-development.53061809.public.multi-containers.ibm.com/store/bucket/preview/omnichannel.json`;
  }
};
